<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-13 11:54:27
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <div  class="batch-operation">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item v-if="codeData.indexOf('280')" @click="caoSong" key="1"> 通过并发布</a-menu-item>
              <a-menu-item v-if="codeData.indexOf('18') != -1" @click="handleMenuClick" key="2"> 批量移出</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /> </a-button>
          </a-dropdown>
        </div>
      </div>
      <div class="right">
        <a-input-group compact>
          <a-select
            v-model:value="selectName"
            style="width: 140px; background: #ccc; margin-left: 12px"
          >
            <a-select-option
              @click="selectFn(item.value)"
              :key="index"
              v-for="(item, index) in selectArr"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-input
            v-model:value="valueName"
            placeholder="请输入搜索内容"
            style="width: 173px"
          />
        </a-input-group>
        <el-button style="margin-left:12px" type="primary"  @click="listSearch"
          ></span>查询</el-button
        >
      </div>
    </div>
    <coententTable
      :y="height"
      :x="1200"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      :isSelectRow="isSelectRow"
      @selectedRowKeys="selectedRowKeys"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :rowKeys="rowKeys"
    >
     
      <template v-slot:columnTitle="scopeVal">
          <div @click="toUrl(scopeVal.scope)" class="title-box">{{scopeVal.scope.title}}</div>
      </template>
      <template v-slot:sourceSiteName="scopeVal">
         <el-popover
            placement="bottom-start"
            trigger="hover"
            :content="scopeVal.scope.sourceParentsName.split(',').join('>')">
            <span slot="reference">{{ scopeVal.scope.sourceSiteName }}</span>
        </el-popover>
      </template>
       <template v-slot:pushColumnName="scopeVal">
         <el-popover
            placement="bottom-start"
            trigger="hover"
            :content="scopeVal.scope.pushParentsName.split(',').join('>')">
            <span slot="reference">{{ scopeVal.scope.pushColumnName }}</span>
        </el-popover>
      </template>
      <template v-slot:stateRizhi="scopeVal">
        <a-popover trigger="click">
          <div class="content" slot="content">
            <div class="open-style" v-for="(item, index) in seeData">
              <div>操作人: {{ item.name || "--" }}</div>
              <div>操作时间: {{ item.time || "--" }}</div>
              <div>描述: {{ item.content || "--" }}</div>
            </div>
          </div>
          <a v-if="codeData.indexOf('19') != -1" @click="see(scopeVal.scope)">查看</a>
        </a-popover>
      </template>
      <template v-slot:operation="scopeVal">
          <div style="display: flex">
              <div  style="margin-right: 14px;width:86px" v-if="codeData.indexOf('315') != -1" @click="editAdmin(scopeVal.scope)" class="btnTwo">通过并发布</div>
                <div
                  @click="open(scopeVal.scope)"
                  class="btnThree"
                  v-if="codeData.indexOf('316') != -1"
                  >移出</div
                >
          </div>
      </template>
    </coententTable>
    <el-dialog
      title="确认移出稿件?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="handleClose"
      top="17%"
    >
      <span>本篇稿件推送流程将终止</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteOne()">确认移出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectPage,
  listPage,
  selectListById,
  remove,
  approvedTwo
} from "../all_manuscripts";
import coententTable from "@/components/coentent_table.vue";
import advancedSearch from "./advanced_search.vue";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      selectName: "标题",
      valueName: "",
      selectValue: 1,
      deleteShow:false,
      isColumn: false,
      dialogVisibleColum: false,
      height: 0,
      value: [],
      dataSourceNews: [],
      isFabu: false,
      value2: "",
      visible: false,
      states: [],
      selectArr: [
        {
          label: "标题",
          value: "1",
        },
        {
          label: "创作人员",
          value: "0",
        },
      ],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          key: "title",
          ellipsis: true,
          scopedSlots: { customRender: "columnTitle" },
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        }
        },
        {
          title: "来源",
          dataIndex: "sourceSiteName",
          key: "sourceSiteName",
          scopedSlots: { customRender: "sourceSiteName" },
          width: 200,
          ellipsis: true,
        },
        {
          title: "推送栏目",
          dataIndex: "pushColumnName",
          key: "pushColumnName",
          scopedSlots: { customRender: "pushColumnName" },
          width: 120,
        },
        {
          title: "创作人员",
          dataIndex: "createUser",
          key: "createUser",
          width: 120,
        },
         {
          title: "推送时间",
          dataIndex: "pushTime",
          key: "pushTime",
          width: 200,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          key: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 200,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "columnTitle",
          customRender: "columnTitle",
        },
        {
          name: "pushColumnName",
          customRender: "pushColumnName",
        },
        {
          name: "sourceSiteName",
          customRender: "sourceSiteName",
        },
      ],
      rowKeys: [],
      seeData: {},
      loading: false,
      isSelectRow: true,
      listPageData: [],
      loading: false,
      dialogVisibleTwo: false,
      dataSourceColunm: [],
      itemColumn: {},
      codeData: [],
      dialogVisibleNews: false,
      width: 0,
      selectChooseIds: [],
    };
  },
  props: ["type"],
  components: {
    coententTable,
    advancedSearch,
  },
  mounted() {
    let current = sessionStorage.getItem("draManuscriptsPage");
    if (current) {
      this.pagination.current = current;
    }
    this.getList();
    this.getListPage();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    toUrl(item){
        window.open(item.viewUrl)
    },
    caoSong() {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      approvedTwo({
         idList: this.rowKeys,
      }).then((res)=>{
            if (res.code == 0) {
                this.rowKeys = [];
                this.getList();
            }
      })
      
    },
    getListPage() {
      listPage({
        siteId: sessionStorage.getItem("siteId"),
        current: 1,
        size: 100000000,
      }).then((res) => {
        if (res.code == 0) {
          this.listPageData = JSON.parse(JSON.stringify(res.data.records));
        }
      });
    },
    handleMenuClick() {
      const _this = this;
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      this.$confirm({
        title: "确定批量移出吗？",
        content: "本篇稿件推送流程将终止",
        centered: true,
        onOk() {
          return new Promise((resolve, reject) => {
             remove({
              idList: _this.rowKeys,
            }).then((res) => {
              if (res.code == 0) {
                _this.getList();
                _this.rowKeys = [];
                setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
              }
            });
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
        class: "test",
      });
    },
    selectFn(value) {
      this.selectValue = value;
    },
    see(item) {
      selectListById({
        id: item.manuscriptId,
      }).then((res) => {
        if (res.code == 0) {
          this.seeData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    editAdmin(item) {
          approvedTwo({
            idList: [item.id],
        }).then((res) => {
            if (res.code == 0) {
                this.getList();
            }
      });
    },
    getList() {
      this.loading = true;
      selectPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.valueName,
        siteId: sessionStorage.getItem("siteId"),
        type: this.selectValue,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        this.$emit('pustChange')
        if (this.pagination.total > 0) {
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
        sessionStorage.removeItem("draManuscriptsPage");
        sessionStorage.removeItem("manuscriptsType");
      });
    },
    onShowSizeChange(current) {
      console.log();
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    handleClose() {
      this.dialogVisibleTwo = false;
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisibleTwo = true;
    },
    deleteOne() {
      this.deleteShow = true;
      remove({
        idList: [this.item.id],
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
    }
    .icon-search-folder:before {
      color: #fff;
      margin-right: 5px;
    }
    .batch-operation {
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.column-style {
  display: flex;
  cursor: pointer;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
/deep/ .ant-table {
  overflow-x: auto;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
.table-title {
  width: 660px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.title-box{
    background-color: rgba(255, 255, 255, 1);
    color: rgba(24, 109, 230, 1);
    font-size: 14px;
    font-family: Microsoft Yahei;
    text-decoration:underline;
    cursor: pointer;
}
</style>